export { VehiclePartSelection, type VehiclePartSelectionProps } from './VehiclePartSelection';
